// What a failed sign-in says to the visitor.
//
// PURE: it takes a Firebase Auth error code and returns the message. One
// message for every code blamed the credentials for a connection failure, and
// a chapter owner cannot tell a password they typed right from a network they
// cannot reach.

export const CREDENTIAL_MESSAGE =
  'Login failed. Please check your email and password.';

export const NETWORK_MESSAGE =
  'We cannot reach One Stop Greek. Check your connection and try again.';

const BY_CODE = {
  'auth/network-request-failed': NETWORK_MESSAGE,
  'auth/invalid-credential': CREDENTIAL_MESSAGE,
  'auth/invalid-email': CREDENTIAL_MESSAGE,
  'auth/user-not-found': CREDENTIAL_MESSAGE,
  'auth/wrong-password': CREDENTIAL_MESSAGE,
  'auth/missing-password': CREDENTIAL_MESSAGE,
  'auth/too-many-requests':
    'Too many sign-in attempts. Wait a few minutes, then try again.',
  'auth/user-disabled':
    'This account is turned off. Write to support@onestopgreek.com.',
};

// An unknown code is not evidence about the password, so it gets its own
// message rather than the credential one.
export const UNKNOWN_MESSAGE =
  'Sign-in failed. Please try again, or write to support@onestopgreek.com.';

export function loginErrorMessage(code) {
  return BY_CODE[code] || UNKNOWN_MESSAGE;
}

export default loginErrorMessage;
